"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketInventoryConfigurationOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketInventoryConfigurationOutput.js.map